export const getFormattedTime = (time) => {
    if (!time) return "No duration";
    const timeObj = new Date(null);
    timeObj.setSeconds(time);
    return timeObj.toISOString().slice(11, 19);
  };
